module.exports = __webpack_public_path__ + "static/media/gcourse5.9bc61e64.png";